export namespace AtencionClienteDashboardActions {
  export class GetTabCounts {
    static readonly type = '[AC Dashboard] Get Tab Counts';
  }

  export class GetOcrStats {
    static readonly type = '[AC Dashboard] Get OCR Stats';
  }

  export class GetStatesPiechart {
    static readonly type = '[AC Dashboard] Get States Piechart';
  }

  export class GetContactsLinechart {
    static readonly type = '[AC Dashboard] Get Contacts Linechart';
    constructor(public startDate: string, public endDate: string) {}
  }

  export class ErrorDashboard {
    static readonly type = '[AC Dashboard] Error';
    constructor(public error: any) {}
  }
}
